import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import axiosInstance from "./AxiosInstance";
import { setCompanyTimezone } from "./utils/utils";
import { setRole } from "./utils/roles";
import Login from "./screens/login/login";
import Dashboard from "./screens/dashboard/dashboard";
import PDUIDetail from "./screens/detail/detail";
import Pduis from "./screens/pduis/pduis";
import RoadMap from "./screens/road_map/road_map";
import Company from "./screens/company/company";
import NetworkMap from "./screens/network_map/network_map";

function LoginRedirect() {
  useEffect(() => {
    window.location.replace("/login");
  }, []);
  return <div></div>;
}

export default function RouteContainer() {
  let authenticated = localStorage.getItem("access") !== null;

  // La zona de la empresa se guarda al iniciar sesión, pero puede cambiar
  // desde otro navegador (página Empresa) o venir de una sesión anterior a
  // la función: se refresca al abrir la plataforma.
  useEffect(() => {
    if (!authenticated) return;
    axiosInstance
      .get("user/company_info/")
      .then((response) => {
        if (response?.data?.timezone) setCompanyTimezone(response.data.timezone);
        if (response?.data?.role) setRole(response.data.role);
      })
      .catch(() => {});
  }, [authenticated]);

  return (
    <Routes>
      {authenticated && (
        <>
          <Route path={"/list"} element={<Pduis />} />
          <Route path={"/"} element={<Dashboard />} />
          <Route path={"/detail/:pdui_id/"} element={<PDUIDetail />} />
          <Route path="imu/" element={<RoadMap />} />
          <Route path="company/" element={<Company />} />
          <Route path="network-map/" element={<NetworkMap />} />
        </>
      )}
      <Route path={"/login"} element={<Login />} />
      <Route path="*" element={<LoginRedirect />} />
    </Routes>
  );
}
